import {
  GTS_FAILURE,
  GTS_PENDING,
  GTS_SUCCESS,
  GNTS_SUCCESS,
  GNTS_FAILURE,
  GNTS_PENDING,
  DT_SUCCESS,
} from './constants'
import {getTemplates as getTemplatesAPI} from '../../../services/templates'

export async function getTemplates(params = {}, dispatch) {
  dispatch({type: GTS_PENDING})
  try {
    let response = await getTemplatesAPI(params)
    dispatch({type: GTS_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Templates Failed`)
    dispatch({type: GTS_FAILURE, payload: e})
  }
}

export async function getNextPageTemplate(params = {}, dispatch) {
  dispatch({type: GNTS_PENDING, payload: []})
  try {
    let response = await getTemplatesAPI(params)
    dispatch({type: GNTS_SUCCESS, payload: response})
    dispatch({type: DT_SUCCESS, payload: 'loading'})
    return response
  } catch (e) {
    console.log(`Get Templates Failed`)
    dispatch({type: DT_SUCCESS, payload: 'loading'})
    dispatch({type: GNTS_FAILURE, payload: e})
    return e.response
  }
}
